import React, { useEffect, useState, useRef, MutableRefObject, useCallback } from 'react';
import { Distance } from 'common/common-components.styled';
import { USER_ROLES } from '../../../constants';
import { sharepointLink } from '../auxiliaries/constants';
import { useIsUserHaveRole } from 'hooks/use-is-user-have-role';
import { getWalleDocumentsFiles } from 'services/support-page-service';
import classes from '../support-page.module.scss';
import Download from 'components/icons/download';
import { WidgetType } from 'components/widget-documnet/widget-documnet-container.props';
import { WidgetDocumnetContainer } from 'components/widget-documnet/widget-documnet-container';
import WidgetHeader from 'components/widget-header/widget-header';
import {
  DownloadsFilesResponse,
  FileSchema,
  ResponseResult,
  SectionModelRepresentation,
  Titles
} from '../auxiliaries/interfaces';
import Spinner from '../../../components/spinner';
import { AxiosResponse } from 'axios';
import { FileInfo } from '../../../components/file-info/file-info';

const DownloadWidget = () => {
  const [links, setLinks] = useState<FileSchema[][]>([]);
  const [widgetSectionNames, setWidgetSectionName] = useState<Titles[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const filesContainerRef: MutableRefObject<HTMLDivElement | null> = useRef<HTMLDivElement>(null);

  const isAdmin = useIsUserHaveRole(USER_ROLES.administrator.id);
  const isMobexoEmpoyee = useIsUserHaveRole(USER_ROLES.mobexoEmployee.id);

  const getPdfFiles = async () => {
    try {
      const { data }: AxiosResponse<DownloadsFilesResponse<ResponseResult>> = await getWalleDocumentsFiles();

      const allFiles: SectionModelRepresentation[] = Object.entries(data?.data as ResponseResult);

      const pdfFiles = allFiles.map(el => {
        return el[1].filter(obj => obj.name.includes('.pdf'));
      });
      const collection = pdfFiles.filter(el => !!el);
      setLinks(collection);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const sectionVisibilityHandler = (titleName: Titles) => {
    const index = widgetSectionNames.indexOf(titleName);
    if (index >= 0) {
      setWidgetSectionName(prevTitles => prevTitles.filter(t => t !== titleName));
      return;
    }
    setWidgetSectionName(prevTitles => [...prevTitles, titleName]);
  };

  const clickHandler = useCallback(
    (ev: MouseEvent) => {
      const target = ev.target as HTMLElement;
      if (filesContainerRef.current && !filesContainerRef.current.contains(target)) {
        if (widgetSectionNames.length) {
          setWidgetSectionName([]);
        }
      }
    },
    [widgetSectionNames]
  );

  useEffect(() => {
    getPdfFiles();
  }, [isAdmin, isMobexoEmpoyee]);

  useEffect(() => {
    document.addEventListener('click', clickHandler);

    return () => {
      document.removeEventListener('click', clickHandler);
    };
  }, [widgetSectionNames]);

  const convertDataToFileInfo = (file: FileSchema) => ({
    filePath: file.path,
    name: file.name || '',
    fileId: file.fileId,
    description: ''
  });

  return (
    <WidgetDocumnetContainer
      className={`${classes.widget} ${classes.widget_download}`}
      type={WidgetType.Simple}
      img={<img src='' />}
    >
      <>
        <WidgetHeader title={'Downloads'} icon={<Download fill='#335566' width='14' height='20' />} />
        <hr className={classes.hr_widget} />
        <div className={classes.download_block}>
          {(isAdmin || isMobexoEmpoyee) && (
            <a href={sharepointLink} key='sharepoint_button' target='_blank'>
              <div key='sharepoint_button_div' className='ml-2'>
                <button className='button-mobexo button-mobexo__main'>Ordner öffnen</button>
                <div className='mb-2' />
              </div>
            </a>
          )}
          {loading ? (
            <div className={classes.spinner_block}>
              <Spinner style={{ width: '35px', height: '40px' }} />
            </div>
          ) : !links.length ? (
            <h6>Neue Dateien müssen hinzugefügt werden</h6>
          ) : (
            <>
              <div ref={filesContainerRef} className={classes.files_block}>
                {links &&
                  links.map(fileList =>
                    fileList.map(file => (
                      <FileInfo
                        key={file.fileId}
                        hideCheckBox
                        hideModifyDate
                        isDownloadButton
                        allFiles={fileList.map(convertDataToFileInfo)}
                        file={convertDataToFileInfo(file)}
                        fileName={file.name || ''}
                        fileSize={0}
                        lastModified=''
                      />
                    ))
                  )}
              </div>
              <Distance top='15' />
            </>
          )}
        </div>
      </>
    </WidgetDocumnetContainer>
  );
};

export default DownloadWidget;
